module.exports = __webpack_public_path__ + "img/ThumbsUpIcon.64d27b6d.svg";